import { render, staticRenderFns } from "./SuggestKeyResultsModal.vue?vue&type=template&id=6aa7e481&scoped=true&"
import script from "./SuggestKeyResultsModal.vue?vue&type=script&lang=js&"
export * from "./SuggestKeyResultsModal.vue?vue&type=script&lang=js&"
import style0 from "./SuggestKeyResultsModal.vue?vue&type=style&index=0&id=6aa7e481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7e481",
  null
  
)

export default component.exports